module.exports = __webpack_public_path__ + "static/media/school-top-ad.b2f24352.png";